import { useNavigate } from "react-router-dom";
import { JSX, useEffect, useState } from "react";
import { useStringTranslation } from "../../hooks/useStringTranslation";

export const LogOutButton = (): JSX.Element => {
    const { t, isLoading: isTranslationsLoading } = useStringTranslation();
    const navigate = useNavigate();
    const [shouldLogout, setShouldLogout] = useState(false);

    useEffect(() => {
        if (shouldLogout) {
            navigate("/logout");
            setShouldLogout(false);
        }
    }, [shouldLogout, navigate]);

    const handleLogout = (): void => {
        setShouldLogout(true);
    };

    return isTranslationsLoading ? (
        <span className="skeleton skeleton-button"></span>
    ) : (
        <span className="log-out" onClick={handleLogout}>
            {t("log-out")}
        </span>
    );
};
